import module from 'app/module.js'

const regexp = /INPUT|SELECT|TEXTAREA/i
const backspace = 8

module.directive('appBackspaceNavigationDisabled', ($document) => {
  return {
    restrict: 'A',
    link () {
      $document.on('keydown keypress', (event) => {
        if (event.which === backspace && (!regexp.test(event.target.tagName) || event.target.disabled || event.target.readOnly)) {
          event.preventDefault()
        }
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/app/directives/app-backspace-navigation-disabled/directive.js